import { getDate } from "../../lib/dateHelper";
import { createRecord } from "../../server/fetchFunctions";
import { uncertainityCalculator } from "./uncertainityCalculator";

export const createCert = async (job: any, deviceParams: any, etalonParams: any, siPrefix: any) => {
  const certificate = await createRecord("certificate", {
    job_id: job.id,
    cal_number_prefix: job.cal_number_prefix,
    cal_number: job.cal_number,
    cal_date: getDate(),
    dev_type: job.device,
    dev_description: job.device_description,
    dev_manufacturer: job.device_manufacturer,
    serial_no: job.serial_no,
    client_name: job.client_name,
    client_address: `${job.client_zip} ${job.client_city}, ${job.client_street}`,
    place_of_cal: "2890 Tata, Kocsi utca 17-19.",
    employee: "Szabó Dávid",
    signer: "Sztehlo Márk",
    based_on: "Gyári specifikáció",
    notes: null,
  });

  const params = await Promise.all(
    deviceParams.map(async (item: any) => {
      const uncert = uncertainityCalculator(item, etalonParams, item.reference_value, 0, siPrefix);
      return await createRecord("certificateResults", {
        certificate_id: certificate.id,
        allowed_deviation: uncert.allowed_deviation,
        deviation: uncert.deviation,
        deviation_precentage: uncert.deviation_precentage,
        device_function: item.device_function,
        device_function_sort_order: item.device_function_sort_order,
        etalon_function_id: item.etalon_function_id,
        etalon_id: item.etalon_id,
        measured_value: 0,
        passed: `${uncert.passed}`,
        range: Number(item.range),
        reference_value: Number(item.reference_value),
        resolution: item.resolution,
        si_prefix_id: item.si_prefix_id,
        si_prefix_symbol: item.si_prefix_symbol,
        u_digit: item.u_digit,
        u_precentage: item.u_precentage,
        u_value: item.u_value,
        uncertainity: uncert.uncertainity,
        unit_symbol: item.unit_symbol,
      });
    })
  );

  return params;
};
